import axios from 'axios'
import {
  CHANGE_EXPENSE_DATA,
  CHANGE_OPTIONS_DATA,
  CLEAR_EXPENSE_DATA,
  GET_ALL_EXPENSES,
  SET_LOADING,
} from './expenseTypes'

export const getAllExpenses = () => async (dispatch, getState) => {
  dispatch({ type: SET_LOADING })
  const options = getState().Expenses.options
  const response = await axios.get('/expenses', { params: options })
  dispatch({
    type: GET_ALL_EXPENSES,
    payload: response.data,
  })
}

export const changeOptionsData = (options) => (dispatch) => {
  dispatch({
    type: CHANGE_OPTIONS_DATA,
    payload: options,
  })
}

export const changeExpenseData = (name, value) => async (dispatch) => {
  dispatch({
    type: CHANGE_EXPENSE_DATA,
    payload: { name, value },
  })
}

export const createExpense = (data) => async (dispatch, getState) => {
  const expense = getState().Expenses.expense
  if (expense.expense || expense.receiptUrl) {
    const expenseData = {
      ...expense,
      ...data,
    }
    await axios.post('/expenses', expenseData)
  }
}

export const clearExpenseData = () => ({
  type: CLEAR_EXPENSE_DATA,
})
